import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import * as XLSX from 'xlsx';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { StatusModalComponent } from '../status-modal/status-modal.component';
import { Subject } from 'rxjs';
import { EmployeeService } from '../../../shared/_services/employee.service';

@Component({
  selector: 'app-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.scss']
})
export class ImportComponent implements OnInit {
  importForm: any;
  fileError: string;
  @ViewChild('uploadFile') uploadFile: any;
  fileTypeError: string;
  statusModal: any;
  private unsubscribe: Subject<void> = new Subject<void>();
  successMsg: string;
  errorMsg: string;
  
  constructor(
    private fb: FormBuilder,
    public bsModalRef: BsModalRef,
    public employeeService: EmployeeService,
    private modalService: BsModalService
  ) {
    this.modalService.onHide
    .takeUntil(this.unsubscribe).subscribe(res => {
      if (this.statusModal) {
        if (this.statusModal.content.srcObject.action == "action1") {
          if (this.statusModal.content.srcObject.type == "catalog-modal") {
            this.bsModalRef.hide();
          }
        }
      }
    });
   }
  
  confirmModalWindow() {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    this.statusModal.content.srcObject = {
      mode: "custom",
      type: 'catalog-modal',
      title: 'Cancel',
      message: `Are you sure you want cancel?`,
      action1: `Yes`,
      action2: 'No',
      action: '',
      style: 'active'
    }
  }

  array_intersect = function(arr1, arr2) {
    console.log('======', arr1, arr2);
    return arr1.filter(function(item) {
        return (arr2.indexOf(item) != -1);
    });
  }

  checkFeilds(data) {
    let validHeaders = ['tratamiento', 'num', 'email', 'nombre', 'apellido1'];
    console.log('======',this.array_intersect(validHeaders, Object.keys(data[0])));
    if(this.array_intersect(Object.keys(data[0]), validHeaders).length == validHeaders.length) {
      return true;
    } else {
      return false;
    }
  }

  checkfile(sender) {
    var validExts = new Array("xlsx", "xls", "csv");
    var fileExt = sender.name.split('.').pop();
    if (validExts.indexOf(fileExt) < 0) {
      return false;
    }
    else return true;
  }

  onFileChange(evt: any) {
    this.fileError = '';  
    this.fileTypeError = '';      
    /* wire up file reader */
      const target: DataTransfer = <DataTransfer>(evt.target);
      if(target.files && target.files.length && this.checkfile(target.files[0])) {
      // if (target.files.length !== 1) throw new Error('Cannot use multiple files');
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});
        let data = [];
        /* grab first sheet */
        // wb.SheetNames.forEach((sheet, i) => {
          let i = 0;
          const wsname: string = wb.SheetNames[i];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];
    
          /* save data */
          data.push(XLSX.utils.sheet_to_json(ws));
        // });
        let xlsData = [].concat.apply([], data);
        if(xlsData && xlsData.length && this.checkFeilds(xlsData)) {
          this.importForm.get('fileName').setValue(target.files[0].name);
          this.importForm.get('fileData').setValue(xlsData);
        } else {
          this.importForm.get('fileName').setValue('');
          this.importForm.get('fileData').setValue('');
          this.fileError = `Selected file doesnot contain required data`;
        }
        this.resetFileInput();
      };
      reader.readAsBinaryString(target.files[0]);
    } else {
      this.importForm.get('fileName').setValue('');
      this.importForm.get('fileData').setValue('');
      this.resetFileInput();
      this.fileTypeError = `Invalid file type selected, valid files are of ${new Array("xlsx", "xls", "csv").toString()} types.`;
    }

  }

  resetFileInput() {
    this.uploadFile.nativeElement.value = "";
  }

  importEmployees() {
    this.employeeService.importEmployees(this.importForm.value).subscribe(res => {
      if(res.error == 0) {
        console.log('Import successfull', res.responseObj);
        this.successMsg = 'Successfully Imported Employee Data'; 
        setTimeout(() => {
          this.successMsg = ''; 
          this.bsModalRef.hide();  
        }, 1500);
      }
    }, err => {
      this.errorMsg = err ? err.message : 'Error Importing Employee Data'; 
        setTimeout(() => {
          this.errorMsg = ''; 
        }, 1500);
      console.error('Error while importing Employee List: ', err.message);
    })
  }

  ngOnInit() {
    this.importForm = this.fb.group({
      fileName: [''],
      fileData: ['', Validators.required],
      action: ['', Validators.required]
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modals/import/import.component.ts